import { render, staticRenderFns } from "./reportFeeDetailContract.vue?vue&type=template&id=28639c22&scoped=true"
import script from "./reportFeeDetailContract.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailContract.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailContract.vue?vue&type=style&index=0&id=28639c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28639c22",
  null
  
)

export default component.exports